import { render, staticRenderFns } from "./ReportSettingsTab.vue?vue&type=template&id=4a649848&scoped=true"
import script from "./ReportSettingsTab.vue?vue&type=script&lang=ts"
export * from "./ReportSettingsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a649848",
  null
  
)

export default component.exports